module.exports = __webpack_public_path__ + "9ba750524c61f1cc5bde1ed0c05b9d03.png";